import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'
import { type ReportSubscriptionType } from './types'

/**
 * Функция отправки подписки для пользователя
 */
export const useSendUserSubscription = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: ReportSubscriptionType) => http.post(`/user/subscriptions`, data),
  })

  const send = async (data: ReportSubscriptionType) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.subscription_success'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}
